__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/52e6fa5c4a15761afe35325bf3c3f5d6a2c52a9b089118270653a69d/";